function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 31.999C24.8366 31.999 32 24.8356 32 15.999C32 7.16247 24.8366 -0.000976562 16 -0.000976562C7.16344 -0.000976562 0 7.16247 0 15.999C0 24.8356 7.16344 31.999 16 31.999Z",
  fill: "#39363A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.5597 17.2873V23.8837H21.7353V17.7294C21.7353 16.1841 21.1831 15.1288 19.7984 15.1288C18.7417 15.1288 18.1139 15.8392 17.8367 16.5272C17.736 16.773 17.71 17.1144 17.71 17.4593V23.8834H13.8853C13.8853 23.8834 13.9366 13.46 13.8853 12.381H17.7103V14.011C17.7026 14.0238 17.6918 14.0364 17.6849 14.0487H17.7103V14.011C18.2186 13.229 19.125 12.1109 21.1571 12.1109C23.6733 12.1109 25.5597 13.7549 25.5597 17.2873ZM9.8843 6.83643C8.57602 6.83643 7.72009 7.69521 7.72009 8.82352C7.72009 9.92787 8.55121 10.8115 9.83411 10.8115H9.85892C11.1929 10.8115 12.0223 9.92787 12.0223 8.82352C11.9969 7.69521 11.1929 6.83643 9.8843 6.83643ZM7.94741 23.8837H11.7707V12.381H7.94741V23.8837Z",
  fill: "#EBECEE"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})));

function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/Linkedin-Logo.2d44bc0c.svg";
export { ForwardRef as ReactComponent };